'use client';

import { Root, Title } from '@radix-ui/react-toast';
import { ComponentPropsWithRef } from 'react';

import CheckIcon from '@synapex/frontend-shared/icons/check-15x12.svg?react';

import classes from './Toast.module.scss';

export type ToastProps = Omit<
  ComponentPropsWithRef<typeof Root>,
  'children'
> & {
  title: string;
};

export const Toast: React.FC<ToastProps> = ({ title, ...rootProps }) => {
  return (
    <Root className={classes.toast} {...rootProps}>
      <CheckIcon className={classes.icon} />

      <Title>{title}</Title>
    </Root>
  );
};
